<template>
  <div style="width: 100%">
    <form class="two-factor-code" @submit.prevent="submit2fa">
      <div class="code-inputs">
        <input
          v-for="(_, index) in code"
          :key="index"
          type="text"
          v-model="code[index]"
          maxlength="1"
          :ref="(e) => (inputRefs[index] = e)"
          @input="handleInput(index, $event)"
          @paste="handlePaste"
        />
      </div>
      <button
        type="submit"
        data-ts="Button"
        :disabled="!isValidTwoFactorCode"
        class="ts-secondary button"
      >
        Verify
      </button>
    </form>
  </div>
</template>

<script setup>
import { ref, nextTick, computed, onMounted } from 'vue';

const emit = defineEmits(['submit']);

const code = ref(Array(6).fill(''));
const inputRefs = ref([]);

const isValidTwoFactorCode = computed(() => {
  return code.value.every(
    (char) => char !== '' && !isNaN(char) && char.length === 1
  );
});

const handleInput = async (index, event) => {
  await nextTick();
  if (event.inputType === 'deleteContentBackward' && index > 0) {
    inputRefs.value[index - 1].focus();
  } else if (event.inputType !== 'deleteContentBackward' && index < 5) {
    inputRefs.value[index + 1].focus();
  }
};

const handlePaste = async (event) => {
  event.preventDefault();
  const pasteData = event.clipboardData.getData('text').slice(0, 6);
  for (let i = 0; i < pasteData.length; i++) {
    code.value[i] = pasteData[i];
  }
  await nextTick();
  if (pasteData.length < 6) {
    inputRefs.value[pasteData.length].focus();
  } else {
    inputRefs.value[5].focus();
  }
};

const submit2fa = () => {
  const codeValue = code.value.join('');
  emit('submit', codeValue);
};

onMounted(() => {
  inputRefs.value[0].focus();
});

const clear = () => {
  code.value = Array(6).fill('');
  inputRefs.value[0].focus();
};

defineExpose({ clear });
</script>

<style scoped>
.code-inputs {
  display: flex;
  justify-content: space-between;
  max-width: 300px;
  margin: 0 auto 20px;
}

.code-inputs input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
